// extracted by mini-css-extract-plugin
export default {"shareButton":"N77zmY"};